import React from 'react';

export interface SharingOptionsRadioButtonProps {
  id: string;
  title: string;
  description: string;
  checked: boolean;
  onCheck: (checked: boolean) => void;
}

export const SharingOptionsRadioButton = (props: SharingOptionsRadioButtonProps) => {
  return (
    <div className="flex gap-3">
      <div className="flex h-6 shrink-0 items-center">
        <div className="group grid size-4 grid-cols-1">
          <input
            id={props.id}
            name="shareMode"
            type="radio"
            checked={props.checked}
            onChange={(e) => {
              props.onCheck(e.target.checked);
            }}
            aria-describedby={`${props.id}-description`}
            className="col-start-1 row-start-1 appearance-none rounded-full border border-gray-300
            bg-white checked:border-indigo-600 checked:bg-indigo-600 focus-visible:outline-2 
            focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:border-gray-300 
            disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto"
          />
          <svg
            fill="none"
            viewBox="0 0 14 14"
            className="pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center
            stroke-white group-has-disabled:stroke-gray-950/25"
          >
            <circle cx="7" cy="7" r="3" className="opacity-0 group-has-checked:opacity-100" />
          </svg>
        </div>
      </div>
      <div className="text-sm/6 text-start">
        <label htmlFor={props.id} className="font-medium text-gray-900">
          {props.title}
        </label>
        <p id={`${props.id}-description`} className="text-gray-500">
          {props.description}
        </p>
      </div>
    </div>
  );
};
